import { ResourcesConfig } from "aws-amplify";

export const awsExport: ResourcesConfig = {
    Auth: {
        Cognito: {
            // @ts-ignore
            region: 'eu-north-1',
            userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
            userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
            loginWith: {
                username: false,
                email: true,
                phone: false,
								oauth: {
									domain: import.meta.env.VITE_COGNITO_OAUTH_DOMAIN,
									scopes: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
									redirectSignIn: [`${window.location.origin}/callback`],
									redirectSignOut: [`${window.location.origin}/auth/signin`],
									responseType: 'code',
								},
            },
            authenticationFlowType: 'CUSTOM_AUTH'
        }
    }
}

